var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRokuinline = function SvgRokuinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C3C97",
    d: "M9.073 6.97c0-1.115-.881-2.013-1.959-2.013h-.971v4.01h.971c1.078 0 1.96-.9 1.96-1.996m4.42 7.993H9.925l-2.831-4h-.952v3.991H3V2.963h4.502c2.596 0 4.714 1.797 4.714 4.008 0 1.348-.812 2.552-2.048 3.29z"
  })));
};
export default SvgRokuinline;